import { Component, Input, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { isUndefined, omit, remove, find, orderBy } from "lodash";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AreYouSureDialogComponent } from 'src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component';
import { UiService } from 'src/app/ui/ui.service';

@Component({
  selector: 'app-catalog-field',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.scss']
})
export class CatalogFieldComponent implements OnInit, AfterViewInit {

  @Input() fields!: any;
  @Input() field!: any;
  @Input() account!: any;
  @Input() index!: number;

  @ViewChild('idInput') idInput!: ElementRef<HTMLInputElement>;

  private onComponentDestroy = new Subject();

  referenceTypes: any[] = [
    {
      label: "Facility",
      value: "facility",
      labels: ["name"]
    }
  ]

  profileFieldTypes: any[] = [
    {
      type: "String",
      options: true,
    },
    {
      type: "String[]",
      options: true,
    },
    {
      type: "Integer",
      options: true,
    },
    {
      type: "Integer[]",
      options: true,
    },
    {
      type: "Float",
      options: true,
    },
    {
      type: "Float[]",
      options: true,
    },
    {
      type: "Date"
    },
    {
      type: "Date[]"
    },
    {
      type: "Boolean",
    },
    {
      type: "Boolean[]"
    },
    {
      type: "Object"
    },
    {
      type: "Object[]"
    },
    {
      type: "CloudinaryImage"
    }
  ];

  constructor(
    private dialog: MatDialog,
    private uiService: UiService,
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Auto-focus the ID field for newly added fields whose temporary ID
    // starts with "field". This improves the flow when creating new
    // profile fields while leaving existing fields unaffected.
    if (
      this.field &&
      typeof this.field.id === "string" &&
      this.field.id.startsWith("field") &&
      this.idInput?.nativeElement
    ) {
      setTimeout(() => {
        this.idInput.nativeElement.focus();
        this.idInput.nativeElement.select();
      });
    }
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  fieldTitle(field: any) {
    return field.name || field.id || "New Field";
  }

  selectedFieldType(type: String) {
    return find(this.profileFieldTypes, (ft) => {
      return ft.type == type;
    });
  }

  showOptionsTitle(field: any) {
    let type = this.selectedFieldType(field._type);
    if(type?.options === true){
      return true;
    }
    return false;
  }

  optionsLabel(field: any) {
    if(field.options){
      return "Options"
    } else if(field.ref){
      return "Reference"
    }
    return "Options or Reference"
  }

  showOptionsType(field: any) {
    let type = this.selectedFieldType(field._type);
    return type?.options;
  }

  doesHaveOptions(field: any) {
    if(field.options){
      return true;
    }
    return false;
  }

  fieldOptionsChange(field: any, type: any) {
    if(type == 'none'){
      delete field.options;
      delete field.ref;
    } else if (type == 'options') {
      field.options = [];
      field.ref = undefined;
    } else if (type == 'ref') {
      field.ref = {
        type: "facility",
        label: "name"
      };
      delete field.options;
    }
  }

  labelsForReference(field: any) {
    return find(this.referenceTypes, (rt) => {
      return rt.value == field.ref.type;
    }).labels;
  }

  fieldOptionChecked(field: any, option: any) {
    if(option == 'none' && field.options == undefined && field.ref == undefined){
      return true;
    } else if(option == 'options' && field.options !== undefined && field.ref == undefined){
      return true;
    } else if(option == 'ref' && field.ref && field.ref !== undefined && field.options == undefined){
      return true;
    }
    return false;
  }

  profileFieldOptionAdd() {
    if (
      isUndefined(this.field.options)
    ) {
      this.field.options = [];
    }
    this.field.options.push({
      label: "Label",
      value: "value",
    });
  }

  profileFieldOptionRemove(fieldIndex: number, optIndex: number) {
    this.field.options.splice(
      optIndex,
      1,
    );
  }

  allowFields() {
    return this.field._type == "Object" || this.field._type == "Object[]";
  }

  addField() {
    if(this.field._type == "Object" || this.field._type == "Object[]"){
      if(this.field.fields == undefined){
        this.field.fields = [];
      }
      this.field.fields.push({
        id: "field" + (this.field.fields.length + 1),
        name: "",
        _type: "String",
        field: "",
        order: -1,
      });
    } else {
      this.fields.push({
        id: "field" + (this.fields.length + 1),
        name: "",
        _type: "String",
        field: "",
        order: -1,
      });
    }
    
  }

  deleteField() {
    this.dialog
      .open(AreYouSureDialogComponent, {
        data: {
          areYouSureInfo: {
            description: `Are you sure you want to delete this field (${this.field.id})?`,
          },
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          remove(this.fields, { id: this.field.id });
        }
    });
  }

}
